// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xasn","left":"styles_left__1B3YI"};